<template>
  <OrderPackingDetail label="Cashbill" :with-fee="false" index-path="/gudang/pengeluaran" />
</template>

<script>
import OrderPackingDetail from '../../../../../components/order/OrderPackingDetail.vue';

export default {
  components: { OrderPackingDetail },
  props: {
    indexPath: String
  }
}
</script>